module.exports = __webpack_public_path__ + "static/media/noun-down-2367384-DEDDDD.66d34ce3.svg";